"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatePriceDto = exports.CreateGroupPricingWithProduct = exports.FindEntitlementGroupByIdDto = exports.GetEntitlementGroupPricingDto = exports.CreateEntitlementGroupsDto = exports.CreateEntitlementGroupDto = exports.EntitlementGroupDto = exports.FindGroupItemsPricingsDto = exports.FindLowestPriceDto = exports.FindEntitlementTermsByVariablesDto = exports.FindEntitlementTermsByGroupIdDto = exports.TermDto = exports.EntitlementTermsDto = exports.CreateEntitlementTermsDto = exports.CreateEntitlementGroupsTermsDto = void 0;
const organization_dto_1 = require("../../organization/dto/organization.dto");
/**
 * This represents the DTO for an array of multiple CreateEntitlementTermsDto objects you want to create at once (ie. data for multiple rows of the
 * Entitlement terms data allstored in 1 object)
 */
class CreateEntitlementGroupsTermsDto {
}
exports.CreateEntitlementGroupsTermsDto = CreateEntitlementGroupsTermsDto;
/**
 * This represents the DTO for creating a single row of the EntitlementTerms table
 */
class CreateEntitlementTermsDto {
}
exports.CreateEntitlementTermsDto = CreateEntitlementTermsDto;
/**
 * This represents the DTO of the entity representing a single row of the EntitlementTerms table
 */
class EntitlementTermsDto extends organization_dto_1.OrganizationBaseEntityDto {
}
exports.EntitlementTermsDto = EntitlementTermsDto;
/**
 * This represents the DTO for a single "term" object (ie. a single object in the terms columns of the EntitlementTerms table)
 */
class TermDto {
}
exports.TermDto = TermDto;
class FindEntitlementTermsByGroupIdDto {
}
exports.FindEntitlementTermsByGroupIdDto = FindEntitlementTermsByGroupIdDto;
class FindEntitlementTermsByVariablesDto {
}
exports.FindEntitlementTermsByVariablesDto = FindEntitlementTermsByVariablesDto;
class FindLowestPriceDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.FindLowestPriceDto = FindLowestPriceDto;
class FindGroupItemsPricingsDto {
}
exports.FindGroupItemsPricingsDto = FindGroupItemsPricingsDto;
class EntitlementGroupDto extends organization_dto_1.OrganizationBaseEntityDto {
}
exports.EntitlementGroupDto = EntitlementGroupDto;
class CreateEntitlementGroupDto {
}
exports.CreateEntitlementGroupDto = CreateEntitlementGroupDto;
class CreateEntitlementGroupsDto {
}
exports.CreateEntitlementGroupsDto = CreateEntitlementGroupsDto;
class GetEntitlementGroupPricingDto {
}
exports.GetEntitlementGroupPricingDto = GetEntitlementGroupPricingDto;
class FindEntitlementGroupByIdDto {
}
exports.FindEntitlementGroupByIdDto = FindEntitlementGroupByIdDto;
class CreateGroupPricingWithProduct {
}
exports.CreateGroupPricingWithProduct = CreateGroupPricingWithProduct;
class CreatePriceDto {
}
exports.CreatePriceDto = CreatePriceDto;
//# sourceMappingURL=pricing.dto.js.map